export default __webpack_public_path__ + "static/media/dti logo.fb9bcd69.png";